import fastResultsTemplate from '../../../public/views/fastResults.html';

/**
 * @ngdoc directive
 * @name directiveApplyFastResult
 * @restrict A
 *
 * @description
 * Directive for fast result list
 *
 * @element ANY
 */
export default function () {
    'ngInject';

    return {
        restrict: 'A', // Only attribute name can be used for directive definition
        scope: {},
        controller: 'directiveApplyFastResultCtrl', // Executes before compile
        template: fastResultsTemplate
    };
}



// WEBPACK FOOTER //
// ./src/js/directives/applyFastResults.js